import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
  accessToken: null,
  refreshToken: null,
  role: [],
  permission: [],
  user_type: [],
};

const normalizeRolesFromAuth = (value) => {
  if (Array.isArray(value)) return value.flatMap(normalizeRolesFromAuth);
  if (value == null) return [];
  return [String(value).trim()].filter(Boolean);
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.email || state.user,
        accessToken: action.payload.access || state.accessToken,
        refreshToken: action.payload.refresh || state.refreshToken,
        permission: action.payload.permissions,
        role: action.payload.role,
        user_type: action.payload.user_type || state.user_type,
      };
    },
    setPermission: (state, action) => {
      state.permission = action.payload;
    },
    updateTokens: (state, action) => {
      state.accessToken = action.payload.access ?? state.accessToken;
      state.refreshToken = action.payload.refresh ?? state.refreshToken;
    },

    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.role = [];
      state.permission = [];
      state.user_type = [];
    },
  },
});

export const { setAuth, setPermission, logout, updateTokens } = authSlice.actions;

export const selectAuth = (state) => state.auth;
export const selectAuthRoles = (state) => normalizeRolesFromAuth(state.auth?.role);
export const selectAuthUserTypes = (state) => normalizeRolesFromAuth(state.auth?.user_type);
export const selectAuthPermissions = (state) => state.auth?.permission || [];

export default authSlice.reducer;
